import * as React from "react";
import { Input as InputPrimitive } from "@base-ui/react/input";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/cn";

/**
 * Brand Input — input ber-identitas SoalHub untuk zona auth & user. Konvensi
 * proyek: `components/ui/input` = stock shadcn (h-8, dipakai form admin via
 * form-fields); surface ber-brand memakai varian di sini — pasangan
 * `BrandButton`. Padding ikon (mis. pl-10 / pr-11) tetap via className
 * call-site (tailwind-merge menimpa sisi terkait dari px-4).
 *
 * Varian (keluarga desain yang sudah hidup di produk):
 *  - brutal: auth & panel utama — h-12, rounded-xl, border-2, hard shadow
 *    (shadow bergeser ke tint primary saat focus).
 *  - soft: form akun user (profil, sandi) — h-11, rounded-xl, ring focus.
 *  - filter: search/filter inline — h-10, bg-muted → bg-card saat focus.
 */
const brandInputVariants = cva(
  "text-foreground placeholder:text-current aria-invalid:border-destructive aria-invalid:ring-destructive/30 w-full text-sm outline-hidden transition-all disabled:cursor-not-allowed disabled:opacity-50",
  {
    variants: {
      variant: {
        brutal:
          "border-border/60 bg-card placeholder:text-foreground/25 focus:border-primary border-2 rounded-xl h-12 px-4 font-medium shadow-soft-md focus:",
        soft: "border-border bg-card placeholder:text-muted-foreground focus:border-primary focus:ring-primary/30 rounded-xl border h-11 px-4 transition-colors focus:ring-1",
        filter:
          "border-border bg-muted text-foreground placeholder:text-foreground/30 focus:border-primary focus:bg-card focus:ring-primary/30 rounded-xl border-2 h-10 px-3 transition-colors focus:ring-1",
      },
    },
    defaultVariants: {
      variant: "soft",
    },
  },
);

function BrandInput({
  className,
  variant,
  type,
  ...props
}: InputPrimitive.Props & VariantProps<typeof brandInputVariants>) {
  return (
    <InputPrimitive
      type={type}
      data-slot="brand-input"
      data-variant={variant}
      className={cn(brandInputVariants({ variant }), className)}
      {...props}
    />
  );
}

export { BrandInput, brandInputVariants };
